// extracted by mini-css-extract-plugin
export default {"DashboardView":"DashboardView_DashboardView__Fx22z","DashboardViewGrid":"DashboardView_DashboardViewGrid__1HhF+","containerLink":"DashboardView_containerLink__2Mjwx"};